import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrCasesApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    caseDashboard(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCaseDashboard>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCaseDashboard>>(`${this.baseUrl}/cases/dashboard`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    cases(owningCompanyId?: number, status?: string, employeeId?: number, limit?: number): Observable<APIResponseWrapper<HrModels.HrCase[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCase[]>>(`${this.baseUrl}/cases`, {
          params: this.params({ owningCompanyId, status, employeeId, limit })
        });
      }
    
    saveCase(request: HrModels.HrCase): Observable<APIResponseWrapper<HrModels.HrCase>> {
        return request.caseId
          ? this.http.put<APIResponseWrapper<HrModels.HrCase>>(`${this.baseUrl}/cases/${request.caseId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrCase>>(`${this.baseUrl}/cases`, request);
      }
    
    updateCaseStatus(caseId: number, request: HrModels.HrCase, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCase>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCase>>(`${this.baseUrl}/cases/${caseId}/status`, request, {
          params: this.params({ owningCompanyId })
        });
      }
    
    sealCase(caseId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCase>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCase>>(`${this.baseUrl}/cases/${caseId}/seal`, {}, {
          params: this.params({ owningCompanyId })
        });
      }
    
    caseActivities(caseId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCaseActivity[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCaseActivity[]>>(`${this.baseUrl}/cases/${caseId}/activities`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    addCaseActivity(caseId: number, request: HrModels.HrCaseActivity): Observable<APIResponseWrapper<HrModels.HrCaseActivity>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCaseActivity>>(`${this.baseUrl}/cases/${caseId}/activities`, request);
      }
    
    caseAttachments(caseId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCaseAttachment[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCaseAttachment[]>>(`${this.baseUrl}/cases/${caseId}/attachments`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    addCaseAttachment(caseId: number, request: HrModels.HrCaseAttachment): Observable<APIResponseWrapper<HrModels.HrCaseAttachment>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCaseAttachment>>(`${this.baseUrl}/cases/${caseId}/attachments`, request);
      }
    
    disciplinaryActions(owningCompanyId?: number, employeeId?: number, caseId?: number): Observable<APIResponseWrapper<HrModels.HrDisciplinaryAction[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrDisciplinaryAction[]>>(`${this.baseUrl}/cases/disciplinary-actions`, {
          params: this.params({ owningCompanyId, employeeId, caseId })
        });
      }
    
    saveDisciplinaryAction(request: HrModels.HrDisciplinaryAction): Observable<APIResponseWrapper<HrModels.HrDisciplinaryAction>> {
        return request.disciplinaryActionId
          ? this.http.put<APIResponseWrapper<HrModels.HrDisciplinaryAction>>(`${this.baseUrl}/cases/disciplinary-actions/${request.disciplinaryActionId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrDisciplinaryAction>>(`${this.baseUrl}/cases/disciplinary-actions`, request);
      }
    
    acknowledgeDisciplinaryAction(actionId: number, owningCompanyId?: number, employeeId?: number): Observable<APIResponseWrapper<HrModels.HrDisciplinaryAction>> {
        return this.http.post<APIResponseWrapper<HrModels.HrDisciplinaryAction>>(`${this.baseUrl}/cases/disciplinary-actions/${actionId}/acknowledge`, {}, {
          params: this.params({ owningCompanyId, employeeId })
        });
      }
    
    caseAccessGrants(caseId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCaseAccessGrant[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCaseAccessGrant[]>>(`${this.baseUrl}/cases/${caseId}/access-grants`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    grantCaseAccess(caseId: number, request: HrModels.HrCaseAccessGrant): Observable<APIResponseWrapper<HrModels.HrCaseAccessGrant>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCaseAccessGrant>>(`${this.baseUrl}/cases/${caseId}/access-grants`, request);
      }
    
    revokeCaseAccess(grantId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCaseAccessGrant>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCaseAccessGrant>>(`${this.baseUrl}/cases/access-grants/${grantId}/revoke`, {}, {
          params: this.params({ owningCompanyId })
        });
      }
  };
}

